/**
 * 应用配置文件
 * 可以根据环境变量或直接配置来控制应用行为
 */

// 获取环境变量（使用类型断言避免 TS 错误）
const getEnvVar = (key: string): string | undefined => {
  try {
    return (import.meta as any).env?.[key];
  } catch {
    return undefined;
  }
};

export const appConfig = {
  /**
   * 是否跳过认证
   * true: 跳过认证，使用开发模式
   * false: 启用手机号+密码认证系统
   * 
   * 可以通过环境变量 VITE_SKIP_AUTH 来覆盖此设置
   * 默认值: false (使用真实认证)
   */
  shouldSkipAuth: getEnvVar('VITE_SKIP_AUTH') === 'true' ? true : false,
  
  /**
   * 开发用户信息（仅在 shouldSkipAuth 为 true 时使用）
   */
  devUser: {
    uid: 'dev-user',
    email: 'dev@example.com',
    isAuthenticated: true
  },

  /**
   * API 配置
   */
  api: {
    baseUrl: getEnvVar('VITE_API_BASE_URL') || 'http://118.178.184.143:48080/app-api',
    tenantId: getEnvVar('VITE_TENANT_ID') || '162',
  },

  /**
   * Cloudflare R2 配置
   * 用于直接上传文件到 R2
   */
  r2: {
    // R2 存储桶的公共访问地址（或自定义域名）
    // 格式: https://<account-id>.r2.cloudflarestorage.com/<bucket-name>
    // 或自定义域名: https://files.yourdomain.com
    endpoint: getEnvVar('VITE_R2_ENDPOINT') || '',
    
    // R2 API Token（用于上传）
    // 在 Cloudflare Dashboard > R2 > Manage R2 API Tokens 创建
    apiToken: getEnvVar('VITE_R2_API_TOKEN') || '',
    
    // R2 Access Key ID（S3 兼容 API）
    accessKeyId: getEnvVar('VITE_R2_ACCESS_KEY_ID') || '',
    
    // R2 Secret Access Key（S3 兼容 API）
    secretAccessKey: getEnvVar('VITE_R2_SECRET_ACCESS_KEY') || '',
    
    // 存储桶名称
    bucketName: getEnvVar('VITE_R2_BUCKET_NAME') || '',
    
    // 公共访问域名（用于生成文件访问 URL）
    publicDomain: getEnvVar('VITE_R2_PUBLIC_DOMAIN') || '',
  }
};

